import React from 'react';
import { BoxV2 as Box, Flex } from 'portal-commons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle,
  faDiamondExclamation,
  faHexagonExclamation,
  faCheckCircle,
} from '@fortawesome/pro-regular-svg-icons';

export type DisplayType = 'info' | 'success' | 'warning' | 'error';

interface StatusMessageBarProps {
  displayType: DisplayType;
  title: string;
  content: React.ReactNode;
}

const STATUS_CONFIG = {
  info: {
    icon: faInfoCircle,
    bg: '#E6F6FC',
    iconBg: '#0091B3',
  },
  warning: {
    icon: faDiamondExclamation,
    bg: '#FEFCE6',
    iconBg: '#FE772D',
  },
  error: {
    icon: faHexagonExclamation,
    bg: '#FCE8EF',
    iconBg: '#B70505',
  },
  success: {
    icon: faCheckCircle,
    bg: '#F4F9E6',
    iconBg: '#23B571',
  },
};

export const StatusMessageBar: React.FC<StatusMessageBarProps> = ({
  displayType,
  title,
  content,
}) => {
  const { icon, bg, iconBg } = STATUS_CONFIG[displayType];

  return (
    <Flex
      data-testid="cspVerificationStatus"
      sx={{
        width: '650px',
        boxSizing: 'border-box',
        backgroundColor: bg,
        border: '1px solid #CCCFD0',
        borderRadius: '8px',
        padding: '16px',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <Flex
        data-testid="cspVerificationMessage"
        sx={{
          alignItems: 'flex-start',
          gap: '16px',
          width: '100%',
        }}
      >
        {/* Icon Wrapper */}
        <Flex
          sx={{
            backgroundColor: iconBg,
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <FontAwesomeIcon icon={icon} fontSize="18px" color="#FFFFFF" />
        </Flex>

        {/* Text Content */}
        <Flex
          sx={{
            flexDirection: 'column',
            gap: '4px',
            pt: '8px',
            flex: 1,
          }}
        >
          <Box
            as="h4"
            sx={{
              fontSize: '14px',
              fontWeight: 600,
              color: '#19262A',
              lineHeight: 'normal',
              margin: 0,
            }}
          >
            {title}
          </Box>
          <Box
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              color: '#4D5659',
              lineHeight: 'normal',
            }}
          >
            {content}
          </Box>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default StatusMessageBar;
